import { useEffect } from 'react'
import { storageKey } from '@/constant/storage'
import { languageInitState } from '@/store/user'
import { useSetRecoilState } from 'recoil'
import { withLocale } from '@/locales'

export const getLocalLanguage = () => {
  if (typeof window === 'undefined') return null
  const userJson = localStorage.getItem(storageKey.USER)
  if (userJson) {
    try {
      const userData = JSON.parse(userJson)
      if (userData.language_code) {
        return userData.language_code
      }
    } catch (error) {
      console.error('Failed to parse user data:', error)
    }
  }

  // 如果没有用户数据或用户未设置语言，则检查直接存储的语言设置
  const directLanguage = localStorage.getItem(
    storageKey.UNLOGGED_USER_SELECTED_LANGUAGE
  )
  return directLanguage || null
}

export const initLanguage = async (language_code?: string) => {
  try {
    // 初始化指定语言
    if (language_code) {
      const pathnameWithLocale = withLocale(
        window.location.pathname,
        language_code
      )
      if (window.location.pathname !== pathnameWithLocale) {
        window.location.href = pathnameWithLocale + window.location.search
      }
      return
    }

    // 初始化为本地 User 或 LocalStorage 缓存中的语言
    const localLanguage = getLocalLanguage()
    if (localLanguage) {
      const pathnameWithLocale = withLocale(
        window.location.pathname,
        localLanguage
      )
      if (window.location.pathname !== pathnameWithLocale) {
        window.location.href = pathnameWithLocale + window.location.search
      }
      return
    }
  } catch (error) {
    console.error('Failed to initialize language:', error)
  }
}

export const useInitLanguage = () => {
  const setLanguageInitState = useSetRecoilState(languageInitState)
  useEffect(() => {
    initLanguage().then(() => {
      setLanguageInitState(true)
    })
  }, [setLanguageInitState])
}
